import {
  LIST_PROCESS_RESEND_ORDER_LIS_REQUEST,
  LIST_PROCESS_RESEND_ORDER_LIS_SUCCESS,
  LIST_PROCESS_RESEND_ORDER_LIS_FAILURE,
  LIST_RESEND_ORDER_LIS_REQUEST,
  LIST_RESEND_ORDER_LIS_SUCCESS,
  LIST_RESEND_ORDER_LIS_FAILURE,
  DETAIL_LIST_PROCESS_RESEND_ORDER_LIS_REQUEST,
  DETAIL_LIST_PROCESS_RESEND_ORDER_LIS_SUCCESS,
  DETAIL_LIST_PROCESS_RESEND_ORDER_LIS_FAILURE,
  DETAIL_PROCESS_RESEND_ORDER_LIS_REQUEST,
  DETAIL_PROCESS_RESEND_ORDER_LIS_SUCCESS,
  DETAIL_PROCESS_RESEND_ORDER_LIS_FAILURE,
  EXPORT_PROCESS_RESEND_ORDER_LIS_REQUEST,
  EXPORT_PROCESS_RESEND_ORDER_LIS_SUCCESS,
  EXPORT_PROCESS_RESEND_ORDER_LIS_FAILURE,
  CREATE_NEW_ORDER_LIS_REQUEST,
  CREATE_NEW_ORDER_LIS_SUCCESS,
  CREATE_NEW_ORDER_LIS_FAILURE,
  UPDATE_ORDER_LIS_REQUEST,
  UPDATE_ORDER_LIS_SUCCESS,
  UPDATE_ORDER_LIS_FAILURE
} from '../../constants/resend-order-lis'

const initialState = {
  listProcessResendOrderLis: [],
  listDetailProcessResendOrderLis: [],
  listResendOrderLis: [],
  detailProcessResendOrderLis: {},
  loading: false,
  loadingCreateOrUpdateLis: false,
  loadingExport: false,
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const resendOrderLisReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_NEW_ORDER_LIS_REQUEST:
      return {
        ...state,
        loadingCreateOrUpdateLis: true
      }
    case CREATE_NEW_ORDER_LIS_SUCCESS:
      return {
        ...state,
        loadingCreateOrUpdateLis: false,
        error: null
      }
    case CREATE_NEW_ORDER_LIS_FAILURE:
      return {
        ...state,
        loadingCreateOrUpdateLis: false,
        error: action.payload
      }

    case UPDATE_ORDER_LIS_REQUEST:
      return {
        ...state,
        loadingCreateOrUpdateLis: true
      }
    case UPDATE_ORDER_LIS_SUCCESS:
      return {
        ...state,
        loadingCreateOrUpdateLis: false,
        error: null
      }
    case UPDATE_ORDER_LIS_FAILURE:
      return {
        ...state,
        loadingCreateOrUpdateLis: false,
        error: action.payload
      }

    case LIST_PROCESS_RESEND_ORDER_LIS_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_PROCESS_RESEND_ORDER_LIS_SUCCESS:
      return {
        ...state,
        loading: false,
        listProcessResendOrderLis: action.payload,
        pageable: action.pageable,
        error: null
      }
    case LIST_PROCESS_RESEND_ORDER_LIS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case LIST_RESEND_ORDER_LIS_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_RESEND_ORDER_LIS_SUCCESS:
      return {
        ...state,
        loading: false,
        listResendOrderLis: action.payload,
        pageable: action.pageable,
        error: null
      }
    case LIST_RESEND_ORDER_LIS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case DETAIL_LIST_PROCESS_RESEND_ORDER_LIS_REQUEST:
      return {
        ...state,
        loading: true
      }
    case DETAIL_LIST_PROCESS_RESEND_ORDER_LIS_SUCCESS:
      return {
        ...state,
        loading: false,
        listDetailProcessResendOrderLis: action.payload,
        pageable: action.pageable,
        error: null
      }
    case DETAIL_LIST_PROCESS_RESEND_ORDER_LIS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case DETAIL_PROCESS_RESEND_ORDER_LIS_REQUEST:
      return {
        ...state,
        loading: true
      }
    case DETAIL_PROCESS_RESEND_ORDER_LIS_SUCCESS:
      return {
        ...state,
        loading: false,
        detailProcessResendOrderLis: action.payload,
        error: null
      }
    case DETAIL_PROCESS_RESEND_ORDER_LIS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case EXPORT_PROCESS_RESEND_ORDER_LIS_REQUEST:
      return {
        ...state,
        loadingExport: true
      }
    case EXPORT_PROCESS_RESEND_ORDER_LIS_SUCCESS:
      return {
        ...state,
        loadingExport: false,
        error: null
      }
    case EXPORT_PROCESS_RESEND_ORDER_LIS_FAILURE:
      return {
        ...state,
        loadingExport: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default resendOrderLisReducer
